
import { useState, useRef, useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from 'react-redux';

//Components
import { Grid } from "@mui/material";
import CustomCard from 'Components/Card';
import {
    Modal,
    ModalBody,
    ModalFooter,
    Button,
    Input,
    Form,
    Select,
} from "@gpstrackit/react-controls";

//Icons
import Success from '@mui/icons-material/CheckCircle';
import Error from '@mui/icons-material/Error';

//Notification
import { NotificationManager } from "Components/Notifications";

//Actions
import {
    changePulsCustomerSearchAccountsRequest,
    changePulsCustomerGetDeviceRequest,
    changePulsCustomerUpdateAccountRequest,
    searchEntityRequest,
    changePulsCustomerSetDevice,
    changePulsCustomerRequest,
    clearRedux,
} from 'Redux/actions';

const changePulsCustomer = (props) => {
    const formRef = useRef(null);
    const formTwoRef = useRef(null);
    const { messages } = useIntl();
    const { tableRef, single, getDevice } = props;
    const dispatch = useDispatch();

    //Redux States
    const { device, loading, openModal, result, devices, selectedDevices, calampApi, ctcAccounts, response } = useSelector(state => state.changePulsCustomerRedux)
    const { pulsCustomers } = useSelector(state => state.generalRedux);

    //Local States
    const [serial, setSerial] = useState("");
    const [step, setStep] = useState(1);
    const [pulsCustomersList, setPulsCustomers] = useState([]);
    const [pulsCustomer, setPulsCustomer] = useState(null);
    const [ctcAccount, setCtcAccount] = useState(null);
    const [ctcResult, setCtcResult] = useState([]);
    const [ctcAccountsList, setCtcAccountsList] = useState([]);

    const searchDevice = () => {
        let deviceSearchCriteriaArr = serial.split(/[\s,;\t\n]+/);
        if (deviceSearchCriteriaArr.length > 1) {
            let criterias = [];
            deviceSearchCriteriaArr.forEach(criteria => {
                let escCriteria = criteria.trim();
                let regx = /[^a-zA-Z0-9]/g;
                escCriteria = escCriteria.replace(regx, '');
                if (devices && devices.length) {
                    for (let index in devices) {
                        let device = devices[index];
                        if (device.imei != escCriteria && device.esn != escCriteria) criterias.push(escCriteria?.trim());
                    }
                } else criterias.push(escCriteria?.trim());
            });

            if (criterias.length) dispatch(changePulsCustomerGetDeviceRequest(criterias));

        } else {

            let isValid = true;
            for (let index in devices) {
                let device = devices[index];
                if (device.esn.toString() === serial?.trim()) {
                    isValid = false;
                    break;
                }
            }

            if (isValid) {
                dispatch(changePulsCustomerGetDeviceRequest(serial?.trim()));
            } else {
                NotificationManager.warning(
                    messages['change_puls_customer_device_is_already_added'],
                    messages['change_puls_customer_title'],
                    3000
                );
            }
        }
    }

    const closeModal = () => {
        setSerial("");
        setStep(1);
        setPulsCustomers([]);
        setPulsCustomer(null)
        dispatch(clearRedux("CHANGE_PULS_CUSTOMER"));
    }

    const applyChanges = () => {

        if (calampApi === "CTC") {
            let unitEsn = devices.map((item) => (item?.esn))
            let payload = {
                esns: unitEsn,
                accountId: ctcAccount?.id
            }
            dispatch(changePulsCustomerUpdateAccountRequest(payload))
        } else {
            let unitIds = devices.map((item) => (item?.id))
            let payload = {
                pulsCustomerId: pulsCustomer?.id,
                unitIds
            }
            dispatch(changePulsCustomerRequest(payload))
        }
    }

    useEffect(() => {
        if (device) {
            dispatch(clearRedux("CHANGE_PULS_CUSTOMER", { device: null }));
            if (!device?.total) {
                NotificationManager.warning(
                    messages['change_puls_customer_device_has_not_been_found'],
                    messages['change_puls_customer_title'],
                    3000
                );
            } else {
                let newCalampApi = device.items[0].unitConfig?.calampApi
                if (devices?.length) {
                    if (calampApi && (calampApi !== newCalampApi)) {
                        NotificationManager.warning(
                            "The device must be of the same calamp api",
                            messages['change_puls_customer_title'],
                            3000
                        );
                        return
                    }
                }

                let currentDevices = device.items;
                let noCalampDevices = currentDevices.filter(x => x.deviceModel?.manufacturer?.name !== "CalAmp")
                let calampDevices = currentDevices.filter(x => x.deviceModel?.manufacturer?.name === "CalAmp");
                if (noCalampDevices?.length > 0) {
                    setSerial("");
                    NotificationManager.warning(
                        messages['devices_main_calamp_error'],
                        messages['change_puls_customer_title'],
                        3000
                    );
                }

                if (calampDevices?.length > 0) {
                    setSerial("");
                    let devicesList = devices
                    devicesList.push(calampDevices[0])
                    dispatch(changePulsCustomerSetDevice(devicesList))
                }

                if (!devices.length) {
                    let newCalampApi = device.items[0].unitConfig?.calampApi
                    dispatch(clearRedux("CHANGE_PULS_CUSTOMER", { calampApi: newCalampApi }))
                }
            }

        }
        if (result?.updatePulsCustomer) {
            if (calampApi === "CTC") {
                let resultCtc = devices.map((item) => {
                    let result = response.find((dv) => dv?.esn === item?.esn)
                    return {
                        ...item,
                        message: result?.message,
                        status: result?.status
                    }
                })
                getDevice && getDevice();
                tableRef && tableRef?.current?.getData();
                setCtcResult(resultCtc);
                setStep(3);

            } else {
                NotificationManager.success(
                    single ? messages['change_puls_customer_single_success_message'] : messages['change_puls_customer_multiple_success_message'],
                    messages['change_puls_customer_title'],
                    3000
                );
                closeModal();
                getDevice && getDevice();
                tableRef && tableRef?.current?.getData();
            }
        } else if (result && !result?.updatePulsCustomer) {
            NotificationManager.error(
                messages['change_puls_customer_error_message'],
                messages['change_puls_customer_title'],
                3000
            );
            dispatch(clearRedux("CHANGE_PULS_CUSTOMER", { result: null }))
        }
        if (selectedDevices && selectedDevices.length > 0) {
            let newDevices = selectedDevices.map((item) => ({ id: item?.id, imei: item?.imei, esn: item?.esn, deviceModel: item?.deviceModel, calampApi: item?.unitConfig?.calampApi }));
            dispatch(changePulsCustomerSetDevice(newDevices));
            dispatch(clearRedux("CHANGE_PULS_CUSTOMER", { selectedDevices: [] }))
        }
    }, [device, result, selectedDevices])

    const sortArrayByKey = (array) => {
        return array.sort(function (a, b) {
            return a.toLowerCase().localeCompare(b.toLowerCase());
        });
    }

    const sortByName = (array) => {
        return array.sort(function (a, b) {
            let nameA = a.name.toLowerCase();
            let nameB = b.name.toLowerCase();
            return nameA.localeCompare(nameB);
        });
    }

    useEffect(() => {
        (!pulsCustomers || pulsCustomers.length === 0) && dispatch(searchEntityRequest({ key: "pulsCustomers" }))
    }, [])

    useEffect(() => {
        if (openModal && pulsCustomers) {
            if (pulsCustomers && pulsCustomers.length > 0) {
                let currentPulsCustomers = sortArrayByKey(pulsCustomers)
                let current = currentPulsCustomers.map((item) => ({ label: `${item}`, id: `${item}` }));
                setPulsCustomers(current);
            }
        }
    }, [pulsCustomers])

    useEffect(() => {
        if (openModal && single && calampApi === "CTC") {
            dispatch(changePulsCustomerSearchAccountsRequest())
        }
    }, [openModal])

    useEffect(() => {
        if (ctcAccounts.length) {
            let ctcAccs = JSON.parse(JSON.stringify(ctcAccounts))
            let newList = sortByName(ctcAccs)
            setCtcAccountsList(newList)
        }
    }, [ctcAccounts])


    let validateStepOne = step === 1 && !single
    let validateStepTwo = step === 2 || single
    let validateStepThree = step === 3 && calampApi === "CTC"

    return (
        <Modal
            open={openModal}
            title={messages['change_puls_customer_title']}
            position="right"
            size="small"
            handleClose={closeModal}
            loading={loading}
        >
            <ModalBody>
                {
                    validateStepOne &&
                    <div style={{ padding: '0 10px' }}>
                        <Grid
                            container
                            spacing={1}
                        >
                            <Grid item xs={10}>
                                <Form
                                    ref={formRef}
                                    onValidSubmit={() => searchDevice()}
                                >
                                    <Input
                                        label={messages['change_puls_customer_input']}
                                        placeholder={messages['change_puls_customer_input']}
                                        value={serial}
                                        required
                                        requiredMessage={messages['required_field']}
                                        onChange={(value) => setSerial(value)}
                                    />
                                </Form>
                            </Grid>
                            <Grid item xs={2}>
                                <div style={{ marginTop: 26 }}>
                                    <Button
                                        className="btn-dark-blue"
                                        onClick={() => formRef?.current?.submit()}
                                    >
                                        {messages['common_add']}
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                        {devices.length > 0 ? devices.map((item, index) => {
                            return (
                                <CustomCard
                                    key={index}
                                    onClick={() => {
                                        let currentDevices = devices;
                                        let selected = currentDevices.findIndex((device) => device?.id === item?.id);
                                        if (selected > -1) currentDevices.splice(selected, 1);
                                        dispatch(changePulsCustomerSetDevice(currentDevices));
                                    }}
                                >
                                    <div style={{ display: 'grid' }}>
                                        <div>
                                            <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['change_puls_customer_imei']}</label><span>{item.imei}</span>
                                        </div>
                                        <div>
                                            <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['change_puls_customer_serial']}</label><span>{item.esn}</span>
                                        </div>
                                        <div>
                                            <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['change_puls_customer_model']}</label><span>{item?.deviceModel?.name}</span>
                                        </div>
                                    </div>
                                </CustomCard>
                            )
                        }) : <div style={{ display: 'flex', justifyContent: 'center', marginTop: 25 }} ><span style={{ opacity: 0.6 }} >{messages['common_no_devices_added']}</span></div>}
                    </div>
                }
                {
                    validateStepTwo &&
                    <div style={{ padding: '0 10px' }}>
                        <Form
                            ref={formTwoRef}
                            onValidSubmit={() => applyChanges()}
                        >
                            {
                                calampApi === "CTC" ?
                                    <Select
                                        id="list-new-ctc"
                                        value={ctcAccount}
                                        options={ctcAccountsList}
                                        label={messages['change_puls_customer_label']}
                                        placeholder={messages['change_puls_customer_label']}
                                        onChange={(item) => setCtcAccount(item)}
                                        valueField="id"
                                        textField="name"
                                        required
                                        requiredMessage={messages['required_field']}
                                    />
                                    :
                                    <Select
                                        id="list-new-pulscustomer"
                                        value={pulsCustomer}
                                        options={pulsCustomersList}
                                        label={messages['change_puls_customer_label']}
                                        placeholder={messages['change_puls_customer_label']}
                                        onChange={(item) => setPulsCustomer(item)}
                                        valueField="id"
                                        textField="label"
                                        required
                                        requiredMessage={messages['required_field']}
                                    />
                            }
                        </Form>
                    </div>
                }
                {
                    validateStepThree &&
                    <div style={{ padding: '0 10px' }}>
                        {ctcResult.length > 0 ? ctcResult.map((item, index) => {
                            return (
                                <CustomCard
                                    key={index}
                                    hideButton
                                >
                                    <div style={{ display: 'grid' }}>
                                        <div>
                                            <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['change_puls_customer_imei']}</label><span>{item.imei}</span>
                                        </div>
                                        <div>
                                            <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['change_puls_customer_serial']}</label><span>{item.esn}</span>
                                        </div>
                                        <div>
                                            <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['change_puls_customer_model']}</label><span>{item?.deviceModel?.name}</span>
                                        </div>
                                        <div>
                                            <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['change_puls_customer_status']}</label>
                                            {
                                                item?.status === "Processed"
                                                    ? <Success style={{ marginRight: 5, color: '#52C6AD' }} />
                                                    : <Error style={{ marginRight: 5, color: '#c94747' }} />
                                            }

                                            <span>{item?.status}</span>
                                        </div>
                                        {
                                            item?.message &&
                                            <div>
                                                <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['change_puls_customer_message']}</label>
                                                <span>{item?.message}</span>
                                            </div>
                                        }
                                    </div>
                                </CustomCard>
                            )
                        }) : <div style={{ display: 'flex', justifyContent: 'center', marginTop: 25 }} ><span style={{ opacity: 0.6 }} >{messages['common_no_devices_added']}</span></div>}
                    </div>
                }
            </ModalBody>
            <ModalFooter>
                {
                    !validateStepThree &&
                    <>
                        <Button
                            className="btn-cancel"
                            onClick={() => closeModal()}
                        >
                            {messages['common_cancel']}
                        </Button>
                        {step === 2 && !single &&
                            <Button
                                className="btn btn-cancel btn-gray"
                                onClick={() => setStep(1)}
                            >
                                {messages['common_back']}
                            </Button>
                        }
                        <Button
                            disabled={step === 1 && devices.length === 0}
                            className="btn-dark-blue"
                            onClick={() => {
                                if (single) formTwoRef?.current?.submit();
                                else {
                                    if (step < 2) {
                                        if (calampApi === "CTC") {
                                            dispatch(changePulsCustomerSearchAccountsRequest())
                                        }
                                        setStep(step + 1);
                                    }
                                    else formTwoRef?.current?.submit();
                                }
                            }}
                        >
                            {step === 1 && !single ? messages['common_next'] : messages['change_puls_customer_change']}
                        </Button>
                    </>
                }
                {
                    validateStepThree &&
                    <Button
                        className="btn-dark-blue"
                        onClick={() => closeModal()}
                    >
                        {messages['common_close']}
                    </Button>
                }
            </ModalFooter>
        </Modal >
    )
}

export default changePulsCustomer;